import PropTypes from "prop-types";
import TextArea from "solar/components/TextArea";
import styles from "components/shared/stays/MessageInput.module.scss";

export default function MessageInput({ name, register }) {
  return (
    <div className={styles.component}>
      <TextArea
        name={name}
        placeholder="Make sure to include your dates."
        register={register}
        minRows={3}
      />
    </div>
  );
}

MessageInput.propTypes = {
  name: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
};
